module.exports = __webpack_public_path__ + "img/it.64fb8212.svg";